module.exports = __webpack_public_path__ + "static/media/lake.5a0118b2.svg";